




import { default as Component } from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import NonCommodityContractAddressWidget from '@/components/widgets/NonCommodityContractAddressWidget.vue';

import NonCommodityPaymentWidget from '@/components/widgets/NonCommodityPaymentWidget.vue';
import NonCommodityBase from './NonCommodityBase.vue';

@Component({
  components: {
    'address-widget': NonCommodityContractAddressWidget,
    'payment-widget': NonCommodityPaymentWidget
  }
})
export default class NonCommodityContractWidget extends NonCommodityBase {
  @Prop() public extendedDataParentKey!: string;

  public paymentSubmitted: boolean = false;
  public addressSubmitted: boolean = false;
  public confirmStep: boolean = false;

  public isLoading: boolean = false;
  protected isSubmittingContract: boolean = false;
  protected isSubmitReadyContract: boolean = false;
  protected isSubmittingPayment: boolean = false;
  protected isSubmitReadyPayment: boolean = false;
  public keyPhrasesWhichRequirePaymentData: string[] = [];

  public setPaymentSubmitted(): void {
    this.paymentSubmitted = true;
    this.isSubmittingPayment = false;
    this.checkStepDone();
  }

  public setAddressSubmitted(): void {
    this.addressSubmitted = true;
    this.isSubmittingContract = false;
    this.checkStepDone();
  }

  protected toggleReadyPending(key: string, isReady: boolean): void {
    if (typeof this[key] == 'boolean') {
      this[key] = isReady;
    }
  }

  public setPending(key: string): void {
    if (key == 'isSubmitReadyPayment') {
      this.isLoading = true;
    }
    this.toggleReadyPending(key, false);
  }

  public setReady(key: string): void {
    if (key == 'isSubmitReadyPayment') {
      this.isLoading = false;
    }
    this.toggleReadyPending(key, true);
  }

  get isReady(): boolean {
    return this.isSubmitReadyPayment && this.isSubmitReadyContract;
  }

  public get isSubmitting(): boolean {
    if (this.isPaymentDataRequired) {
      return this.isSubmittingContract && this.isSubmittingPayment;
    }
    return this.isSubmittingContract;
  }

  public submittingWasUnsuccessful(): void {
    this.isSubmittingContract = false;
    this.isSubmittingPayment = false;
  }

  public submitForms(): void {
    this.submitContract();
    if (this.isPaymentDataRequired) {
      this.submitPayment();
    }
  }

  public submitContract(): void {
    this.isSubmittingContract = true;
    // @ts-ignore
    if (!this.$refs.addressWidget || !this.$refs.addressWidget.contractSubmit) {
      console.error('Address widget: contractSubmit undefined!');
      return;
    }
    // @ts-ignore
    this.$refs.addressWidget.contractSubmit();
  }

  public submitPayment(): void {
    this.isSubmittingPayment = true;
    // @ts-ignore
    if (!this.$refs.paymentWidget || !this.$refs.paymentWidget.paymentSubmit) {
      console.error('Address widget: paymentSubmit undefined!');
      return;
    }
    // @ts-ignore
    this.$refs.paymentWidget.paymentSubmit();
  }

  protected checkStepDone(): void {
    if (this.paymentSubmitted && this.addressSubmitted) {
      this.$emit('contractSubmit');
    }
  }

  get isPaymentDataRequired(): boolean {
    if (this.isFleetFlow) {
      return true;
    }
    let isRequired = false;
    for (let index = 0; index < this.keyPhrasesWhichRequirePaymentData.length; index++) {
      const requirementPhrase = this.keyPhrasesWhichRequirePaymentData[index].toLowerCase();
      const productCodeLower = this.store.state.nonCommodityProductData.productCode.toLowerCase();
      if (productCodeLower.includes(requirementPhrase)) {
        isRequired = true;
        break;
      }
    }
    if (!isRequired) {
      this.paymentSubmitted = true;
      this.isSubmitReadyPayment = true;
    }
    return isRequired;
  }
}
